<template>
  <v-select
    v-model="internalValue"
    :outlined="outlined"
    :items="blocks"
    :dense="dense"
    item-value="id"
    item-text="name"
    :label="label"
    @input="$emit('input', internalValue)" />
</template>

<script>
export default {
  name: 'BlockSelect',
  props: {
    value: {
      type: [Number, String],
      required: true,
    },
    dense: {
      type: Boolean,
      default: true,
    },
    label: {
      type: String,
      default: 'ブロック',
    },
    allowEmpty: {
      type: Boolean,
      default: false,
    },
    outlined: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    internalValue: 3,
    blocks: [],
  }),
  watch: {
    value(val) {
      this.internalValue = val
    },
  },
  mounted() {
    this.fetchItems()
  },
  methods: {
    async fetchItems() {
      const { data } = await window.axios.get('/api/blocks')
      this.blocks = this.allowEmpty
        ? [{ id: '', name: '-- 選択してください --' }, ...data]
        : data
    },
  },
}
</script>

<style scoped>

</style>
